'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _ByArtistName = require('components/ByArtistName/ByArtistName');

var _ByArtistName2 = _interopRequireDefault(_ByArtistName);

var _FromLabel = require('components/FromLabel/FromLabel');

var _FromLabel2 = _interopRequireDefault(_FromLabel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = require('./PlaylistAlbumInfo.scss');

var PlaylistInfo = (_temp = _class = function (_PureComponent) {
  (0, _inherits3.default)(PlaylistInfo, _PureComponent);

  function PlaylistInfo() {
    (0, _classCallCheck3.default)(this, PlaylistInfo);
    return (0, _possibleConstructorReturn3.default)(this, (PlaylistInfo.__proto__ || (0, _getPrototypeOf2.default)(PlaylistInfo)).apply(this, arguments));
  }

  (0, _createClass3.default)(PlaylistInfo, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          album = _props.album;
      var t = this.context.t;


      return _react2.default.createElement(
        'div',
        { className: (0, _bind2.default)(styles.albumInfo, className) },
        _react2.default.createElement(
          'div',
          { className: styles.infoTable },
          _react2.default.createElement(
            'div',
            { className: styles.infoCell },
            _react2.default.createElement(
              'div',
              { className: styles.albumName },
              album.albumName
            ),
            _react2.default.createElement(
              'div',
              { className: styles.artist },
              _react2.default.createElement(_ByArtistName2.default, { artistName: album.artist_name })
            ),
            _react2.default.createElement(
              'div',
              { className: styles.smallHeader },
              t('Sent by'),
              ':'
            ),
            _react2.default.createElement(
              'div',
              { className: styles.sentBy },
              _react2.default.createElement(
                'div',
                null,
                album.senderName || album.sender
              ),
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_FromLabel2.default, { labelName: album.labelName })
              ),
              _react2.default.createElement(
                'div',
                null,
                album.fullSentDate
              )
            )
          )
        )
      );
    }
  }]);
  return PlaylistInfo;
}(_react.PureComponent), _class.propTypes = {
  album: _propTypes2.default.object,
  className: _propTypes2.default.string
}, _class.contextTypes = {
  t: _propTypes2.default.func
}, _class.defaultProps = {
  album: {}
}, _temp);
exports.default = PlaylistInfo;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Playlist/PlaylistAlbumInfo/PlaylistAlbumInfo.js
// module id = 2042
// module chunks = 1